export type Flags = Record<string, boolean>;

export const trueToArray = (flags: Flags): string[] => Object.keys(flags).filter(key => flags[key]);
